import { Avatar, Chip } from "@mui/material";
import * as React from "react";

export interface LinkedGoogleAccountProps {
  email: string;
  onClickUnlink: () => void;
}

export const LinkedGoogleAccount = ({
  email,
  onClickUnlink,
}: LinkedGoogleAccountProps) => {
  return (
    <Chip
      label={email}
      color="default"
      variant="outlined"
      onDelete={onClickUnlink}
      avatar={<Avatar src="images/google.png" />}
    />
  );
};
